import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    days: 'days',
    label: 'Quote validity period',
  },
  fr: {
    days: 'jours',
    label: 'Période de validité du devis',
  },
} as const);

export default locales;
